package com.shadowings.gero.data.lessons.chapter17

import com.shadowings.gero.data.lessons.chapter16.mdcSlide
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_sdm_f_congiuntivo_1
import gero.composeapp.generated.resources.exp_content_sdm_f_congiuntivo_10
import gero.composeapp.generated.resources.exp_content_sdm_f_congiuntivo_11
import gero.composeapp.generated.resources.exp_content_sdm_f_congiuntivo_12
import gero.composeapp.generated.resources.exp_content_sdm_f_congiuntivo_13
import gero.composeapp.generated.resources.exp_content_sdm_f_congiuntivo_14
import gero.composeapp.generated.resources.exp_content_sdm_f_congiuntivo_15
import gero.composeapp.generated.resources.exp_content_sdm_f_congiuntivo_16
import gero.composeapp.generated.resources.exp_content_sdm_f_congiuntivo_17
import gero.composeapp.generated.resources.exp_content_sdm_f_congiuntivo_18
import gero.composeapp.generated.resources.exp_content_sdm_f_congiuntivo_19
import gero.composeapp.generated.resources.exp_content_sdm_f_congiuntivo_2
import gero.composeapp.generated.resources.exp_content_sdm_f_congiuntivo_20
import gero.composeapp.generated.resources.exp_content_sdm_f_congiuntivo_21
import gero.composeapp.generated.resources.exp_content_sdm_f_congiuntivo_3
import gero.composeapp.generated.resources.exp_content_sdm_f_congiuntivo_4
import gero.composeapp.generated.resources.exp_content_sdm_f_congiuntivo_5
import gero.composeapp.generated.resources.exp_content_sdm_f_congiuntivo_6
import gero.composeapp.generated.resources.exp_content_sdm_f_congiuntivo_7
import gero.composeapp.generated.resources.exp_content_sdm_f_congiuntivo_8
import gero.composeapp.generated.resources.exp_content_sdm_f_congiuntivo_9
import gero.composeapp.generated.resources.exp_title_sdm_f_congiuntivo

fun getSdmFCongiuntivoContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_sdm_f_congiuntivo,
            content = Res.string.exp_content_sdm_f_congiuntivo_1,
            face = Faces.Doubt,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_sdm_f_congiuntivo,
            content = Res.string.exp_content_sdm_f_congiuntivo_2,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_sdm_f_congiuntivo,
            content = Res.string.exp_content_sdm_f_congiuntivo_3,
            face = Faces.Idle,
            character = Characters.Alyn,
            composable = mdcSlide("E34:N35-G17-A2-A1"),
        ),
        ExplanationContent(
            title = Res.string.exp_title_sdm_f_congiuntivo,
            content = Res.string.exp_content_sdm_f_congiuntivo_4,
            face = Faces.Idle,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_sdm_f_congiuntivo,
            content = Res.string.exp_content_sdm_f_congiuntivo_5,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_sdm_f_congiuntivo,
            content = Res.string.exp_content_sdm_f_congiuntivo_6,
            face = Faces.Surprised,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_sdm_f_congiuntivo,
            content = Res.string.exp_content_sdm_f_congiuntivo_7,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_sdm_f_congiuntivo,
            content = Res.string.exp_content_sdm_f_congiuntivo_8,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_sdm_f_congiuntivo,
            content = Res.string.exp_content_sdm_f_congiuntivo_9,
            face = Faces.Idle,
            character = Characters.Alyn,
            composable = mdcSlide("F21-G17-V31"),
        ),
        ExplanationContent(
            title = Res.string.exp_title_sdm_f_congiuntivo,
            content = Res.string.exp_content_sdm_f_congiuntivo_10,
            face = Faces.Idle,
            character = Characters.Alyn,
            composable = mdcSlide("F21-G17-V31-D21:Aa1-Y1A-V31"),
        ),
        ExplanationContent(
            title = Res.string.exp_title_sdm_f_congiuntivo,
            content = Res.string.exp_content_sdm_f_congiuntivo_11,
            face = Faces.Doubt,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_sdm_f_congiuntivo,
            content = Res.string.exp_content_sdm_f_congiuntivo_12,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_sdm_f_congiuntivo,
            content = Res.string.exp_content_sdm_f_congiuntivo_13,
            face = Faces.Serious,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_sdm_f_congiuntivo,
            content = Res.string.exp_content_sdm_f_congiuntivo_14,
            face = Faces.Idle,
            character = Characters.Alyn,
            composable = mdcSlide("G43-U28-G1-Y1"),
        ),
        ExplanationContent(
            title = Res.string.exp_title_sdm_f_congiuntivo,
            content = Res.string.exp_content_sdm_f_congiuntivo_15,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_sdm_f_congiuntivo,
            content = Res.string.exp_content_sdm_f_congiuntivo_16,
            face = Faces.Happy,
            character = Characters.Alyn,
            composable = mdcSlide("G43-U28-G1-Y1-O1h2:Z1-V31"),
        ),
        ExplanationContent(
            title = Res.string.exp_title_sdm_f_congiuntivo,
            content = Res.string.exp_content_sdm_f_congiuntivo_17,
            face = Faces.Idle,
            character = Characters.Alyn,
            composable = mdcSlide("G43-U28-G1-Y1-G39-A1-V31"),
        ),
        ExplanationContent(
            title = Res.string.exp_title_sdm_f_congiuntivo,
            content = Res.string.exp_content_sdm_f_congiuntivo_18,
            face = Faces.Happy,
            character = Characters.Masko,
            composable = mdcSlide("G43-U28-G1-Y1-D46:Q3*X1-P1-N35:Z2"),
        ),
        ExplanationContent(
            title = Res.string.exp_title_sdm_f_congiuntivo,
            content = Res.string.exp_content_sdm_f_congiuntivo_19,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_sdm_f_congiuntivo,
            content = Res.string.exp_content_sdm_f_congiuntivo_20,
            face = Faces.Serious,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_sdm_f_congiuntivo,
            content = Res.string.exp_content_sdm_f_congiuntivo_21,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
    )
}
